import { t as Swiper } from "./swiper-bundle.esm.js";
//#region frontend/entrypoints/sf-slideshow.js
document.addEventListener("DOMContentLoaded", () => {
	const swiperContainer = document.querySelector(".swiper.c-slideshow");
	if (swiperContainer) {
		const autoplay = swiperContainer.dataset.autoplay === "true";
		const slideDelay = parseInt(swiperContainer.dataset.slideDelay, 10);
		const slideSpeed = parseInt(swiperContainer.dataset.slideSpeed, 10);
		swiperContainer.querySelectorAll(".swiper-slide");
		new Swiper(swiperContainer, {
			loop: true,
			loopedSlides: 3,
			slidesPerView: 1,
			autoplay: autoplay ? {
				delay: slideDelay,
				disableOnInteraction: false
			} : false,
			speed: slideSpeed,
			pagination: {
				el: ".swiper-pagination",
				clickable: true
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
				addIcons: false
			}
		});
	}
});
//#endregion
